// extracted by mini-css-extract-plugin
export default {"productList":"edit-shipment-modal_productList__UwRIp","selectorWrapper":"edit-shipment-modal_selectorWrapper__4g8ld"};